
import {
  defineComponent, ref, computed,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import slider from './components/slider.vue';
import tapbar from './components/tapbar.vue';
import breadCrumbs from './components/breadcrumb.vue';
import activeLabel from './components/activeLabel.vue';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
  components: {
    slider, tapbar, activeLabel, breadCrumbs,
  },
  data() {
    const path = ref();
    const userSelectPath = (e) => {
      path.value = e;
    };
    const collapsed = ref(false);
    const store = useStore();
    const cachePath = computed(() => store.getters.cacheComponentsPath);
    const needCache = computed(() => {
      let hasPath = false;

      cachePath.value.forEach((item) => {
        if (path.value === item) {
          hasPath = true;
        }
      });
      return hasPath;
    });

    const toggleCollapsed = (e) => {
      collapsed.value = e;
    };

    const route = useRoute();

    const loading = ref(false);

    const unRefreshPathList = ['/materialcode', '/rdprojectlayout'];

    watch(() => route, (val) => {
      const unRefresh = unRefreshPathList.findIndex((f) => f === val.path) !== -1;
      if (!unRefresh) {
        loading.value = true;
        setTimeout(() => {
          loading.value = false;
        }, 0)
      }
    }, {
      deep: true,
    });

    return {
      path,
      collapsed,
      needCache,
      loading,
      userSelectPath,
      toggleCollapsed,
    };
  },
  methods: {

  },
});
